import React, { useContext, useMemo } from "react";
import { Checkbox } from "@mui/material";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";

const SelectMessageCheckbox = ({ message }) => {
    const { showSelectMessageCheckbox, selectedMessages, toggleSelectedMessage } = useContext(ForwardMessageContext);

    const isChecked = useMemo(() => selectedMessages.some(m => m.id === message.id), [selectedMessages, message?.id]);

    if (showSelectMessageCheckbox) {
        return (
            <Checkbox
              color="primary"
              checked={isChecked}
              onChange={() => toggleSelectedMessage(message)}
            />
        );
    } else {
        return null;
    }
}

export default SelectMessageCheckbox;